import { ChangeDetectionStrategy, Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { Store } from '@ngrx/store';

import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { getAllFaq, getFaqGroupedByDepartmentThenCategory, groupFaqs } from '../../store/selectors/faq.selector';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { exampleFaqs } from 'src/app/styleguide/exampledata/example-entities';
import { toSignal } from '@angular/core/rxjs-interop';
import { FaqSectionComponent } from '../../components/faq-section/faq-section.component';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { StringUtility, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { RouterLink } from '@angular/router';
import { SetCanonical, SetTags, SetTitle } from 'src/app/store';
import { ImageSharpConfig, ResizePipe } from '@teamfoster/sdk/image';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./faq-page.component.scss'],
  imports: [HeaderComponent, FaqSectionComponent, UrlRewritePipe, RouterLink, FromDictionaryPipe],
})
export class FaqPageComponent implements OnInit {
  private store = inject(Store);
  lang = inject(LanguageService);
  private dict = new FromDictionaryPipe(this.lang);
  faq$ = this.store.selectSignal(getAllFaq);

  // Dirty fix to make sure the faqs are displayed in the correct order. Jorn said this would never change.
  private order: Record<string, number> = {
    'CODA Museum': 1,
    'CODA Centrale Bibliotheek': 2,
    'CODA ExperienceLab': 3,
    'CODA Archief & Erfgoed': 4,
    'CODA Daktuin': 5,
  };

  groupedFaq$ = this.store.selectSignal(getFaqGroupedByDepartmentThenCategory);
  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);

  getKeys(obj: { [key: string]: any }) {
    var keys = Object.keys(obj);

    const sorted = keys.sort((a, b) => {
      return (this.order[a] ?? 999) - (this.order[b] ?? 999);
    });

    return keys;
  }

  ngOnInit(): void {
    this.setMetaData();
  }

  setMetaData() {
    const title = this.dict.transform('faq-overzicht-meta-titel', false) || this.dict.transform('faq-overzicht-titel');
    const description = this.dict.transform('faq-overzicht-meta-beschrijving');
    const image = this.dict.transform('faq-overzicht-meta-afbeelding-url', false) || this.dict.transform('meta-afbeelding-url', false);
    const resizeImage = new ResizePipe(ImageSharpConfig);

    const meta: { [key: string]: string } = {
      'description': StringUtility.Truncate(description, 157, '...'),
      'og:title': `${title} ${this.dict.transform('meta-titel-suffix')}`,
      'og:description': StringUtility.Truncate(description, 157, '...'),
    };

    if (image) {
      meta['og:image'] = 'https:' + resizeImage.transform(image, 1200, 630, 'middlecenter');
    }

    this.store.dispatch(
      SetTitle({
        title: `${title} ${this.dict.transform('meta-titel-suffix') ? '- ' + this.dict.transform('meta-titel-suffix') : ''}`,
      })
    );
    this.store.dispatch(SetCanonical({ url: `${environment.canonicalDomain}/faq` }));
    this.store.dispatch(
      SetTags({
        properties: meta,
      })
    );
  }
}
